import { Deserializable } from '../_common/deserializable';

export class Retention implements Deserializable{
    day: string;
    reports: [];

    deserialize(input: any): this {
      return Object.assign(this, input);
    }
}
